import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=1fa4c529"
import script from "../../services/teacher/teacher-list.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/teacher-list.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports